import React from 'react'
import { CrewListItem } from '../../../../types'
import { useTranslation } from 'react-i18next';
import { VisaStatus } from '../../../VisaStatus/VisaStatus';
import { useSelector } from 'react-redux';
import { createFileURL } from 'src/utils/new';

export const CrowTable = ({ crews, visaStatus, selectedCrews, onSelectCrews }: { crews: (CrewListItem & { nationFA?: string, nationEN?: string })[], visaStatus: number, selectedCrews: string[], onSelectCrews: (items: string[]) => void }) => {


    const user = useSelector((state) => (state as any).user.user)

    const isAgent = user?.role_key === "agent"

  const lng = useSelector((state) => (state as any).common.lng)


    const { t } = useTranslation();

    const rowBaseClassName = isAgent ? 'grid grid-cols-10 [&>span]:col-span-1 [&>span]:text-center text-sm p-2' : 'grid grid-cols-9 [&>span]:col-span-1 [&>span]:text-center text-sm p-2'

    const textGen = (text?: string) => text ? text : '-'

    const genderGen = (gender?: number) => gender == 1 ? t('man') : t('woman')

    const toggleAll = (state: boolean) => {
        if (state) onSelectCrews([])
        else onSelectCrews(crews.map(i => i.crew_id))

    }

    const isAllSelected = selectedCrews.length == crews.length
console.log(crews)
    return (
        <div className='flex flex-col gap-2 w-full'>
            <div className={`${rowBaseClassName}  text-gray-800 uppercase bg-[#e2e2e2] `}>
                {isAgent && <span><input type='checkbox' className='rounded accent-[#03acff] cursor-pointer' checked={isAllSelected} onChange={({ target: { checked } }) => !checked ? toggleAll(true) : toggleAll(false)} /></span>}
                <span>#</span>
                <span>{t('photo')}</span>
                <span>{t('nameAndSurname')}</span>
                <span>{t('work')}</span>
                <span>{t('nation')}</span>
                <span>CDC</span>
                <span>{t('passport')}</span>
                <span>{t('gender')}</span>
                <span>{t('status')}</span>

            </div>


            {crews?.length > 0 && crews?.map((item, index) => {

                // console.log(item)

                if (!!item?.crew) {

                    const { crew: { nationality, cdc_no, passport_no, gender, picture }, visa_job, job, visa: { status }, id, crew_id  , nationEN , nationFA} = item

                    const isCrewSelected = selectedCrews.indexOf(crew_id) != -1

                    return <div className={`${rowBaseClassName} items-center`}>
                        {isAgent && <span><input type='checkbox' className='rounded accent-red cursor-pointer' checked={isCrewSelected} onChange={({ target: { checked } }) => !checked ? onSelectCrews(selectedCrews.filter(i => i != crew_id)) : onSelectCrews([...selectedCrews, crew_id])} /></span>}
                        <span>{index + 1}</span>
                        <div className='flex flex-row justify-center relative'>

                            {picture ? <img src={createFileURL(picture)} className='w-10 h-10 rounded-full  border ' /> : <div className='bg-gray-50 rounded-full border w-10 h-10'></div>}
                        </div>
                        <span>{item?.crew?.name ?? '-'} {item?.crew?.last_name ?? '-'}</span>
                        <span>{textGen(visa_job?.[0]?.name)}</span>
                        <span>{lng=='fa' ? nationFA :  nationEN}</span>
                        <span>{textGen(cdc_no)}</span>
                        <span>{textGen(passport_no)}</span>
                        <span>{typeof gender == 'number' ? genderGen(gender) : '-'}</span>
                        <span className='flex flex-row justify-center'>
                            <VisaStatus status={status} />
                        </span>
                    </div>
                }
                else return <div className='text-center text-gray-500 text-sm py-2'>{t('CrewIsEmpty')}</div>
            })}

        </div>
    )
}
